export default __webpack_public_path__ + "static/media/Amper_photo_04.053259d6.jpg";